import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";


export class Unit extends EntityDto implements IEntityDto {
  Unit_Id: string;
  UnitName: string; 
  UnitPrefix:string;
  Company_Id: string;
  CompanyName: string;
  Division_Id: string;
  DivisionName: string;
  Location_Id: string;
  LocationName: string;
  Department_Id: string;
  DepartmentName: string;
  SubDepartment_Id: string;
  SubDepartmentName: string;
  TotalCount: number;
  IsActive: boolean;
  Emp_Ref_Id: string;
  EmployeeName: string;
  EmailId: string;
  Phone: string;
  constructor() {
    super();
    this.Unit_Id = '00000000-0000-0000-0000-000000000000';
    this.UnitName = ''; 
    this.UnitPrefix = "";
    this.Company_Id = "";
    this.CompanyName = "";
    this.Division_Id = "";
    this.DivisionName = "";
    this.Location_Id = '';
    this.LocationName = '';
    this.Department_Id = ''; 
    this.DepartmentName = '';
    this.SubDepartment_Id = ''; 
    this.SubDepartmentName = '';
    this.TotalCount = 0;
    this.IsActive = true;
    this.Emp_Ref_Id = '';
    this.EmployeeName = '';
    this.EmailId = "";
    this.Phone = "";
    this.EntityMetaData = [
      { FieldName: 'UnitName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Unit Name is required' },
      { FieldName: 'UnitPrefix', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' }, 
   // {FieldName : 'SubDepartment_Id' , FieldType: FieldType.String, IsMandatory:true, ValidationMessage: 'Sub Department is required'},
     // { FieldName: 'Emp_Ref_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Unit Head is required' },
      
      // { FieldName: 'Division_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Division is required' },
      // { FieldName: 'Location_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Location is required' }, 
  //  {FieldName : 'Department_Id' , FieldType: FieldType.String, IsMandatory:true, ValidationMessage: ' Department is required'},
      // { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'EmailId is required' },
      // { FieldName: 'Phone', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Phone is required' },
      
   ];
  } 
}